<template>
  <el-dialog @close="dialogClose"
             :visible.sync="visible"
             :title="(dialogStatus==='create'?'新增':'修改')+(dialogType==='rule'?'规则':'流水')"
             :close-on-click-modal="false"
             class="edit-rule-dialog">
    <el-form :model="editFormData"
             ref="editRuleForm"
             :rules="formRules"
             class="edit-form"
             label-width="80px">
      <el-form-item prop="rule_code_value"
                    v-if="dialogType!=='flow'"
                    label="规则编号">
        <el-input placeholder="请输入规则编号"
                  v-model="editFormData.rule_code_value"></el-input>
      </el-form-item>
      <el-form-item prop="parentName"
                    v-if="dialogType==='flow'"
                    label="规则名称">
        <el-input :disabled="true"
                  placeholder="请输入规则名称"
                  v-model="editFormData.parentName"></el-input>
      </el-form-item>
      <el-form-item prop="name"
                    v-if="dialogType!=='flow'"
                    label="规则名称">
        <el-input placeholder="请输入规则名称"
                  v-model="editFormData.name"></el-input>
      </el-form-item>
      <el-form-item prop="name"
                    v-if="dialogType==='flow'"
                    label="流水名称">
        <el-input placeholder="请输入流水名称"
                  v-model="editFormData.name"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogClose"
                 id="back-style">取 消</el-button>
      <el-button type="primary"
                 @click="editRule"
                 id="headLeftSelect">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EncodeRuleApi } from '@/services/EncodeRule'
export default {
  data () {
    return {
      visible: false,
      editFormData: {
        name: '',
        system_no: '',
        resolve_type: '',
        resolve_no: '',
        company_id: 0,
        rule_code_value: ''
      },
      tempData: {
        name: '',
        system_no: '',
        resolve_type: '',
        resolve_no: '',
        company_id: 0,
        rule_code_value: ''
      },
      formRules: {
        rule_code_value: [
          { required: true, message: '请输入规则编号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogForm: {
      type: Object
    },
    dialogStatus: {
      type: String
    },
    dialogType: {
      type: String
    },
    callback: {
      type: Function
    }
  },
  watch: {
    dialogVisible (newval) {
      this.visible = newval
    },
    dialogForm: {
      handler (newval) {
        let tempData = JSON.parse(JSON.stringify(this.tempData))
        this.editFormData = Object.assign(tempData, JSON.parse(JSON.stringify(newval)))
      },
      deep: true
    }
  },
  methods: {
    handleClose () {

    },
    dialogClose () {
      this.$emit('update:dialogVisible', false)
    },
    // 根据状态和类型新增或编辑规则和流水段
    editRule () {
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          if (this.dialogStatus === 'create') {
            this.createRule()
          } else {
            this.updateRule()
          }
        }
      })
    },
    // 新增规则或流水段
    createRule () {
      EncodeRuleApi.createEncodeTree({
        data: this.editFormData
      }).then(res => {
        if (res.code === 0) {
          let message = this.dialogType === 'rule' ? '新增规则成功' : '新增流水段成功'
          this.$message.success(message)
          this.$emit('callback', res)
          this.dialogClose()
        }
      }, err => {
        console.log(err)
      })
    },
    // 编辑规则或流水段
    updateRule () {
      EncodeRuleApi.updateEncodeTree({
        data: this.editFormData
      }).then(res => {
        if (res.code === 0) {
          let message = this.dialogType === 'rule' ? '修改规则成功' : '修改流水段成功'
          this.$message.success(message)
          this.$emit('callback', res)
          this.dialogClose()
        }
      })
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.edit-rule-dialog {
  .dialog-footer {
    text-align: center;
  }
  .back-style{
    margin-right:12px
  }
}

</style>



// WEBPACK FOOTER //
// src/components/EncodeTree/components/EditRuleDialog.vue